// extracted by mini-css-extract-plugin
export default {"logoutIframe":"Logout-index__logoutIframe--V8OCa"};